/* eslint-disable no-nested-ternary */
import { SUPPLIER_CREATE } from '@constants';
import { SupplierForm, toSupplierPayload } from '@forms/SupplierForm';
import { SupplierFormValues } from '@forms/SupplierForm/types';
import { useAuthHttp } from '@hooks';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDocumentTitle } from 'usehooks-ts';

export function AddSupplier() {
  useDocumentTitle('FLOX - Add Supplier');
  const authHttp = useAuthHttp();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const pages = [
    { name: 'Home', href: '/', current: false },
    { name: 'Suppliers', href: '/supplier-master', current: false },
    { name: 'Add New Supplier', href: '/supplier/add', current: true },
  ];

  const handleOnSubmit = async (data: SupplierFormValues) => {
    setIsSubmitting(true);
    try {
      const { data: createSupplierData } = await authHttp.post(
        SUPPLIER_CREATE,
        {
          supplier: toSupplierPayload(data),
        },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (createSupplierData) {
        navigate('/supplier-master');
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <SupplierForm
      onSubmit={handleOnSubmit}
      isSubmitting={isSubmitting}
      pages={pages}
      header='New Supplier'
    />
  );
}
